import openSocket from "socket.io-client";
import {
  getBackendSocketPath,
  getBackendSocketUrl
} from "../config";

function getToken() {
  let token = localStorage.getItem("token");
  if (token) {
    try {
      token = JSON.parse(token);
    } catch (e) {
      // token pode ja estar sem aspas
    }
  }
  return token;
}

function connectToSocket() {
  const socket = openSocket(getBackendSocketUrl(), {
    path: getBackendSocketPath(),
    transports: ["websocket", "polling", "flashsocket"],
    query: {
      token: getToken()
    }
  });

  // O token de acesso expira em 15min. Em toda reconexao, reenvia o token
  // atual do localStorage (mantido fresco pelo refresh periodico do useAuth),
  // senao o handshake usa o token antigo e o servidor derruba a conexao.
  const refreshQueryToken = () => {
    socket.io.opts.query = { token: getToken() };
  };
  socket.io.on("reconnect_attempt", refreshQueryToken);

  // Quando o app volta do background (iOS PWA suspende o socket), reconecta
  // com token novo para retomar as mensagens ao vivo sem precisar reabrir.
  const onVisible = () => {
    if (
      document.visibilityState === "visible" &&
      !socket.connected &&
      getToken()
    ) {
      refreshQueryToken();
      socket.connect();
    }
  };
  document.addEventListener("visibilitychange", onVisible);

  // Quando o servidor forca a desconexao (token invalido no handshake), o
  // socket.io v3 NAO reconecta sozinho. Reconecta manualmente com token novo,
  // com um pequeno atraso para evitar loop agressivo.
  socket.on("disconnect", reason => {
    if (reason === "io client disconnect") {
      // desconexao intencional (unmount do componente): remove o listener.
      document.removeEventListener("visibilitychange", onVisible);
      return;
    }
    if (reason === "io server disconnect") {
      setTimeout(() => {
        if (getToken()) {
          refreshQueryToken();
          socket.connect();
        }
      }, 2000);
    }
  });

  return socket;
}

export default connectToSocket;
